import React, { useEffect, useState } from 'react';
import { INotificationItemProps } from './notification-item.type';
import { LazyLoadImage, PostDetailComponent } from '../../../../components';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useReadNotification } from '../../notification.hook';
import { getNotificationIcon } from './notification-item.function';
import PreviewPostDialog from '../../../../components/preview-post-dialog/preview-post-dialog.component';
import { INotificationItem, IPostModel } from '../../../../models';
import { getDetailPost } from '../../../../api';
import { readNotificationApi } from '../../../../api/notification';

export const NotificationItem: React.FC<INotificationItemProps> = (props) => {
  const {
    userName,
    imageUrl,
    content,
    timeStamp,
    notification,
    onRead,
    isDropdown,
    onClick,
  } = props;
  // const [notificationId, setNotificationId] = useState<string | null>(null);
  // const { isLoading, error } = useReadNotification(
  //   notificationId || '',
  //   onRead
  // );

  const markNotificationAsRead = async (id: string) => {
    try {
      await readNotificationApi(id);
      onRead();
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
    }
  };
  const [visiblePreview, setVisiblePreview] = useState<boolean>(false);
  const [postId, setPostId] = useState<string>('');
  const navigator = useNavigate();
  const [detailPostData, setDetailPostData] = useState<any>({});

  useEffect(() => {
    if (postId) {
      handleGetDetailPost(postId);
    }
  }, [postId]);

  const handleGetDetailPost = async (postId) => {
    const res = await getDetailPost(postId);
    setDetailPostData(res);
  };

  const handleNotificationClick = async (notification: INotificationItem) => {
    onClick && onClick();
    if (!notification?.isRead) {
      try {
        await readNotificationApi(notification.id);
        onRead();
      } catch (error) {
        console.error('Failed to mark notification as read:', error);
      }
    }
    switch (notification.notificationType) {
      case 'UnLikeComment':
      case 'LikeComment':
      case 'HiddenPost':
      case 'UnLikePost':
      case 'ReplyComment':
      case 'Share':
      case 'DonatePost':
      case 'LikePost':
      case 'CreatePost':
      case 'Comment':
        setPostId(notification.referenceId);
        setVisiblePreview(true);
        break;
      case 'FriendRequest':
        navigator('/profile?tab=friend&subTab=request');
        break;
      case 'InviteJoinGroup':
      case 'AdminDeletePostInGroup':
      case 'AdminDeletePostInFanpage':
        navigator(`/group/${notification.referenceId}`);
        break;
      case 'AcceptFriend':
      case 'BirthdayFriend':
      case 'FollowUser':
      case 'UnFollowUser':
        navigator(`/user/${notification.referenceId}`);
        break;
      case 'CreateWithdrawalRequest':
      case 'ApproveRequestCreateWithdrawal':
      case 'CreateRequestReceiveDonation':
      case 'ApproveRequestReceiveDonation':
        navigator('/profile?tab=history-donate');
        break;
      case 'Chat':
        navigator('/chat');
        break;
      case 'DonateCreator':
      case 'QualifiedCreator':
      case 'SystemDonatePost':
      case 'SystemDonateCreator':
      case 'NotApprovedPost':
      case 'ApprovedPost':
        break;
      default:
        // Thông báo sàn hợp tác gửi người thuê vẫn trỏ "/ads" (notification-service dựa vào chuỗi này để chọn câu cho
        // người thuê); khu người thuê nay là trang Thuê creator riêng, nên đổi đích ngay tại đây.
        if (String(notification.notificationType || '').startsWith('Brand') && String(notification.referenceUrl || '').startsWith('/ads')) {
          navigator('/hire-creators');
          break;
        }
        // Loại chưa có case riêng (vd BlindBoxWin) → điều hướng theo referenceUrl nếu backend gửi kèm.
        if (notification.referenceUrl) navigator(notification.referenceUrl);
    }
  };

  const handleClose = () => {
    setPostId('');
    setDetailPostData({});
    setVisiblePreview(false);
  };

  return (
    <>
      <div
        onClick={() => handleNotificationClick(notification)}
        className={`flex px-3 gap-2 items-center py-2 border-b border-b-[#E5E7EB] dark:border-b-slate-700 cursor-pointer hover:bg-gray-100 dark:hover:bg-zinc-800
      transition-all duration-200 `}
      >
        <div className="relative flex-col flex-shrink-0 align-start">
          <LazyLoadImage
            className={`rounded-full  ${
              isDropdown ? 'w-10 h-10' : ' w-[60px] h-[60px]'
            }`}
            alt="avatar"
            src={imageUrl || '/default-avatar.svg'}
          />
          <div className="absolute right-0 bottom-0 bg-[#0071A6] w-5 h-5 flex justify-center items-center rounded-full dark:border-gray-800">
            {getNotificationIcon(notification.notificationType)}
          </div>
        </div>
        <div
          className={`flex flex-col  text-start  ${
            isDropdown ? 'gap-1' : 'gap-2'
          }`}
        >
          {userName && (
            <span
              className={` font-bold  dark:text-white ${
                notification.isRead ? 'text-[#657384]' : 'text-[#111827]'
              }
            
            ${isDropdown ? 'text-[14px]' : 'text-base '}
            `}
            >
              {userName}
            </span>
          )}

          <span
            className={` font-semibold   dark:text-white ${
              notification.isRead ? 'text-[#657384]' : 'text-[#111827]'
            }
           ${isDropdown ? 'text-[12px]' : 'text-sm '}
          `}
          >
            {content}
          </span>
          <div
            className={`font-light dark:text-blue-500 ${
              notification.isRead ? 'text-[#657384]' : 'text-[#0071A6]'
            }
           ${isDropdown ? 'text-[11px]' : 'text-sm '}
          `}
          >
            <span>{dayjs.utc(timeStamp).fromNow()}</span> <span />
          </div>
        </div>
      </div>
      {detailPostData &&
        detailPostData?.postImageResponses &&
        detailPostData?.postImageResponses?.length > 0 && (
          <PreviewPostDialog
            visible={visiblePreview}
            onclose={handleClose}
            post={detailPostData || ({} as IPostModel)}
            initialSlide={0}
          />
        )}
    </>
  );
};
